import { useNavigate } from 'react-router';

import useSharedCardActions from './useSharedCardActions';

import type { GeneratorFunction } from './types';

const useMatchingCoachActions = (): GeneratorFunction => {
  const navigate = useNavigate();
  const { handleClick } = useSharedCardActions();

  return ({ card }) => {
    const label = 'View';
    return [
      {
        label,
        onClick: () => {
          handleClick({ card, label, shouldUpdate: false });
          navigate('/m/sessions/upcoming');
        },
      },
    ];
  };
};

export default useMatchingCoachActions;
